import React from 'react'
import { Autocomplete } from '@atd/rui-base.mui.autocomplete'
import { TextField } from '@atd/rui-base.mui.text-field'
import { connect } from 'react-redux'
import MapboxClient from 'mapbox'
import * as locationActions from './locationActions'
import { bindActionCreators } from 'redux'

function mapStateToProps(state, ownProps) {
    return {
        geolocation: state.scout.geolocation,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(locationActions, dispatch),
    }
}

const mapboxClient = new MapboxClient(process.env.MAP_KEY)

class GeocodeSearch extends React.Component {
    state = {
        dataSource: [],
        searchText: '',
    }

    handleGeocodeRequest = (value) => {
        mapboxClient.geocodeForward(value, this.handleGeocodeResponse)
    }

    handleGeocodeResponse = (err, response) => {
        if (!err) {
            this.setState({ dataSource: [...response.features] })
        }
        else {
            this.setState({ dataSource: [] })
        }
    }

    handleGeocodeSelect = (chosenRequest, index) => {
        let feature
        if (index >= 0) {
            feature = this.state.dataSource[index]
        }
        else if (this.state.dataSource.length) {
            feature = this.state.dataSource[0]
        }
        if (feature) {
            this.props.selectGeolocation(feature)
            this.setState({dataSource: [], searchText: feature.place_name})
        }
    }

    render() {
        return (
            <Autocomplete
                fullWidth
                freeSolo
                openOnFocus
                filterOptions={(opts) => opts}
                options={this.state.dataSource}
                getOptionLabel={(option) => (typeof option === 'string' ? option : (option.place_name || ''))}
                inputValue={this.state.searchText}
                onInputChange={(_, value, reason) => {
                    this.setState({searchText: value})
                    if (reason === 'input') this.handleGeocodeRequest(value)
                }}
                onChange={(_, value) => {
                    if (value && typeof value !== 'string') {
                        const index = this.state.dataSource.indexOf(value)
                        this.handleGeocodeSelect(value, index)
                    }
                }}
                disabled={this.props.disabled}
                renderInput={(params) => (
                    <TextField {...params} variant="standard" placeholder="Location Search" name="locationSearch"/>
                )}
            />
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GeocodeSearch)
